module.exports = __webpack_public_path__ + "static/media/quiz.a11ca742.svg";